import CalculateTree from "./CalculateTree/CalculateTree.js"
// import {createTreeDataWithMainNode} from "./handlers/newPerson.js"

export default function createStore(initial_state) {
  let onUpdate;
  const state = {
    ...initial_state,
    initialData: JSON.parse(JSON.stringify(initial_state.data)),
  },
    update = {
      tree: (props) => {
        state.tree = calcTree((props && props.contract) || false);
        if (onUpdate) onUpdate(props)
      },
      mainId: main_id => state.main_id = main_id,
      data: data => state.data = data,
      relationshipPathNodes:[]
    },
    getData = () => state.data,
    getTree = () => state.tree,
    setOnUpdate = (f) => onUpdate = f,
    methods = {}
  return {state, update, getData, getTree, setOnUpdate, methods}


  function calcTree(contract) {
    const useBackup = Array.isArray(state.backupStash) && state.backupStash.length > 0;
    const dataToUse = useBackup ? state.backupStash : state.data;

    if (useBackup) {
        state.data=state.backupStash;
        state.backupStash = []; // clear it after use
    }
    return CalculateTree({
      data_stash: dataToUse, main_id: state.main_id,
      node_separation: state.node_separation, level_separation: state.level_separation,contract:contract,setBackup: (backup) => state.backupStash = backup,state 
    })
  }
}